export default "__VITE_ASSET__zqMfnlPF__"